export default {
  ekobisnis: 'Ekonomi - Berbisnis di Indonesia',
  ekohubung: 'Ekonomi - Berbisnis di Wilayah Kerja KJRI New York',
  ekolain: 'Ekonomi - Lainnya',
  ekopameran: 'Ekonomi - Pameran Budaya dan Pariwisata',
  ekodagang: 'Ekonomi - Pameran Dagang'
};
